// bm-design-system: testimonial carousel
//
// A thin wrapper over the generic Carousel that maps testimonial data to
// Testimonial cards. Auto-scroll, pause-on-hover, and hover/focus arrows all come
// from Carousel; this just owns the item shape and card mapping.
import type * as React from "react";
import { Carousel } from "@/components/ui/carousel";
import { Testimonial } from "@/components/ui/testimonial";

export interface TestimonialItem {
  quote: React.ReactNode;
  name: string;
  attribution?: React.ReactNode;
  profileImage?: string;
}

export interface TestimonialCarouselProps {
  items: TestimonialItem[];
  className?: string;
  /** Auto-advance interval in ms; 0 disables. Passed through to Carousel. */
  autoAdvanceMs?: number;
}

export function TestimonialCarousel({
  items,
  className,
  autoAdvanceMs,
}: TestimonialCarouselProps) {
  return (
    <Carousel
      className={className}
      ariaLabel="Client testimonials"
      autoAdvanceMs={autoAdvanceMs}
    >
      {items.map((t, i) => (
        <Testimonial
          key={i}
          quote={t.quote}
          name={t.name}
          attribution={t.attribution}
          profileImage={t.profileImage}
          className="snap-start"
        />
      ))}
    </Carousel>
  );
}
